/* eslint-disable no-barrel-files/no-barrel-files */
// TODO: De-barrel-ize
import { OverlayPopupMenu } from 'features/overview/components/OverlayPopupMenu'
import { type CentralizedHealthScore, NoRLHealthScore } from 'types'

import {
  AggregateDataFetch,
  AggregateUnitData,
  useAggregateSiteData,
} from './aggregateSiteData'
import { useFetchBulkHealthData } from './api/fetchHealthData'
import {
  type NeededDataFetch,
  useFetchNeededSiteDataFromRolodex,
} from './api/fetchRolodexData'
import { BottomOverlayMenuButton } from './BottomOverlayMenuButton'
import { SiteViewAssetVizPanel } from './components/assetVizPanel/SiteViewAssetVizPanel'
import { SiteViewAssetVizWrapper } from './components/assetVizPanel/SiteViewAssetVizWrapper'
import { SiteViewBottomOverlays } from './components/bottomOverlays/SiteViewBottomOverlays'
import {
  HealthScorePill,
  HealthScorePillProps,
} from './components/healthScore/HealthScorePill'
import { MapPlusButton } from './MapPlusButton'
import { NavigationButton } from './NavigationButton'
import { RolodexTilesPlugin } from './rolodexTilesPlugin'
import {
  assembleAssetTrackerBreakdown,
  AssetTrackerBreakdown,
} from './sidebar/assembleAssetTrackerBreakdown'
import { getEmptyPlot } from './sidebar/assemblePlotData'
import {
  BreakdownItemSelectionStatus,
  generateHealthScoreDisplayItem,
  NotEnoughDataItem,
} from './sidebar/AssetTrackerScoreBreakdownDisplayItem'
import { sumCostsInYearRange } from './sidebar/capExCardHelpers'
import {
  convertSiteViewAggregateDataToTableFormat,
  SiteViewTableData,
} from './sidebar/convertSiteViewAggregateDataToTableFormat'
import {
  getDataQualityCountDisplayObjs,
  getHealthScoreCountDisplayObjs,
} from './sidebar/GetAssetTrackerCountBreakdownDisplayObjs'
import {
  HealthConditionChipGroup,
  type HealthConditionChipOption,
} from './sidebar/HealthConditionChipGroup'
import { SiteViewAssetTrackerCountDisplay } from './sidebar/SiteViewAssetTrackerCountDisplay'
import { FilterFunc, FilterFuncMap } from './sidebar/types/unitFilteringTypes'
import {
  SiteViewFilterKey,
  useGetSidebarComponentFilterFns,
} from './sidebar/useGetSidebarComponentFilterFns'
import {
  DefaultSiteViewContextProvider,
  useSiteViewContext,
} from './state/SiteViewContext'
import { SiteViewFeatureGenerationConfig } from './state/siteViewFeatureGenerationConfig'
import { getYearlyCostsByUnit } from './utils/getPlanCostsByUnit'
import {
  listYearsToSimTo,
  NUM_YEARS_ABLE_TO_SIM_TO,
} from './utils/numYearsAbleToSimTo'
import {
  CardBorderRadius,
  generateSiteViewCheckerboardColor,
  generateSiteViewStripedColor,
  getBreakdownDisplayBackgroundColorWithOpacity,
  useSiteViewColors,
} from './utils/siteViewTheme'
import { useCanVisitSiteView } from './utils/useCanVisitSiteView'
import { useGetUnitDisplayPropertiesFn } from './utils/useGetUnitDisplayPropertiesFn'
export {
  type AggregateDataFetch,
  type AggregateUnitData,
  assembleAssetTrackerBreakdown,
  type AssetTrackerBreakdown,
  BottomOverlayMenuButton,
  BreakdownItemSelectionStatus,
  CardBorderRadius,
  type CentralizedHealthScore,
  convertSiteViewAggregateDataToTableFormat,
  DefaultSiteViewContextProvider,
  type FilterFunc,
  type FilterFuncMap,
  generateHealthScoreDisplayItem,
  generateSiteViewCheckerboardColor,
  generateSiteViewStripedColor,
  getBreakdownDisplayBackgroundColorWithOpacity,
  getDataQualityCountDisplayObjs,
  getEmptyPlot,
  getHealthScoreCountDisplayObjs,
  getYearlyCostsByUnit,
  HealthConditionChipGroup,
  type HealthConditionChipOption,
  HealthScorePill,
  type HealthScorePillProps,
  listYearsToSimTo,
  MapPlusButton,
  NavigationButton,
  type NeededDataFetch,
  NoRLHealthScore,
  NotEnoughDataItem,
  NUM_YEARS_ABLE_TO_SIM_TO,
  OverlayPopupMenu,
  RolodexTilesPlugin,
  SiteViewAssetTrackerCountDisplay,
  SiteViewAssetVizPanel,
  SiteViewAssetVizWrapper,
  SiteViewBottomOverlays,
  type SiteViewFeatureGenerationConfig,
  SiteViewFilterKey,
  type SiteViewTableData,
  sumCostsInYearRange,
  useAggregateSiteData,
  useCanVisitSiteView,
  useFetchBulkHealthData,
  useFetchNeededSiteDataFromRolodex,
  useGetSidebarComponentFilterFns,
  useGetUnitDisplayPropertiesFn,
  useSiteViewColors,
  useSiteViewContext,
}
